// MAX_SAFE_INTEGER is Number.MAX_SAFE_INTEGER. IE doesn't have it, so declare
// it explicitly.
export const MAX_SAFE_INTEGER = 2147483647;

export const IntTooBig = (i) => i > MAX_SAFE_INTEGER;
